<template>
  <nav
    class="flex items-center justify-between px-8 py-4 z-30"
    :class="{ 'absolute w-full': $route.path === '/' }"
  >
    <div class="navbar-brand">
      <router-link :to="{ name: 'home' }" class="navbar-item logo2 pb-0">
        <img :src="require('@/assets/logoGreen.png')" alt="Sqwerv green logo" />
      </router-link>
    </div>
    <div class="hidden md:flex items-center space-x-4">
      <div v-for="link in navLinks" :key="link.text" class="relative">
        <router-link
          v-if="link.name"
          :to="{ name: link.name }"
          class="font-semibold text-lg hover:text-yellow-400 hover:underline"
          :class="{
            'text-base-content': $route.path !== '/',
            'text-white': $route.path === '/',
            'text-yellow-400 underline': $route.name === link.name,
          }"
        >
          {{ link.text }}
        </router-link>
        <div v-else class="relative">
          <button
            @click="toggleMerchDropdown"
            class="font-semibold text-lg hover:text-yellow-400 hover:underline flex items-center"
            :class="{
              'text-base-content': $route.path !== '/',
              'text-white': $route.path === '/',
            }"
          >
            {{ link.text }}
            <svg
              class="w-4 h-4 ml-1"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M19 9l-7 7-7-7"
              ></path>
            </svg>
          </button>
          <div
            v-if="merchDropdownVisible && link.children"
            class="absolute right-0 mt-2 w-56 bg-neutral bg-opacity-90 rounded-md shadow-lg z-50"
          >
            <a
              v-for="child in link.children"
              :key="child.text"
              :href="child.href"
              target="_blank"
              class="block px-4 py-3 text-base text-neutral-content hover:bg-gray-700"
            >
              {{ child.text }}
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="md:hidden">
      <button @click="isMenuOpen = !isMenuOpen">
        <svg
          class="w-6 h-6"
          :class="{
            'text-primary': $route.path === '/',
            'text-base-content': $route.path !== '/',
          }"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M4 6h16M4 12h16M4 18h16"
          ></path>
        </svg>
      </button>
    </div>
    <div
      v-if="isMenuOpen"
      class="absolute top-16 right-4 bg-neutral bg-opacity-75 rounded-lg p-4 flex flex-col space-y-2 md:hidden z-40"
    >
      <div v-for="link in navLinks" :key="link.text">
        <router-link
          v-if="link.name"
          :to="{ name: link.name }"
          @click="isMenuOpen = false"
          class="font-semibold text-lg hover:text-yellow-400 hover:underline"
          :class="{
            'text-neutral-content': true,
            'text-yellow-400 underline': $route.name === link.name,
          }"
        >
          {{ link.text }}
        </router-link>
        <div v-else>
          <button
            @click="toggleMerchDropdown"
            class="font-semibold text-lg text-neutral-content w-full text-left flex items-center"
          >
            {{ link.text }}
            <svg
              class="w-4 h-4 ml-1"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M19 9l-7 7-7-7"
              ></path>
            </svg>
          </button>
          <div v-if="merchDropdownVisible" class="flex flex-col pl-4">
            <a
              v-for="child in link.children"
              :key="child.text"
              :href="child.href"
              target="_blank"
              @click="isMenuOpen = false"
              class="font-semibold text-md text-neutral-content hover:text-yellow-400 hover:underline"
            >
              {{ child.text }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script setup>
import { ref } from 'vue'

const isMenuOpen = ref(false)
const merchDropdownVisible = ref(false)

const toggleMerchDropdown = () => {
  merchDropdownVisible.value = !merchDropdownVisible.value
}

const navLinks = [
  { name: 'home', text: 'HOME' },
  { name: 'shows', text: 'SHOWS' },
  { name: 'about', text: 'ABOUT' },
  { name: 'videos', text: 'VIDEOS' },
  { name: 'press', text: 'PRESS' },
  { name: 'contactUs', text: 'CONTACT US' },
  {
    text: 'MERCH',
    children: [
      {
        href: 'https://sqwerv-goldmine.myshopify.com/',
        text: 'Merch Site',
      },
      {
        href: 'https://shop.mixtapemeditation.com/products/sqwerv-wonder-lp-limited-edition-variant?variant=50524485714198#936b1936c43afb9dc315cdf7fb1e5e7e',
        text: 'Wonder Vinyl',
      },
      {
        href: 'https://shop.mixtapemeditation.com/products/sqwerv-hors-doeuvres-limited-edition-vinyl?variant=50524503310614',
        text: "Hors d'Oeuvres Vinyl",
      },
    ],
  },
]
</script>

<style scoped>
.logo2 img {
  padding-top: 30px;
  width: 185px !important;
  max-height: 120px !important;
}

@media screen and (max-width: 1023px) {
  .logo2 img {
    padding-top: 0;
    width: 130px !important;
    max-height: 100px !important;
  }
}
</style>
